import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-theme-setting',
  templateUrl: './theme-setting.component.html',
  styleUrls: ['./theme-setting.component.scss']
})
export class ThemeSettingComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
